import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@rynora/theme/style.css';
// `pending-shared-ui-primitives` v0.3.2 — pulls in the `.rui-tabs__*`
// (+ button / input / modal / card) primitive baseline. `styles.css`
// + per-component CSS files (e.g. `product-demo.css`) load AFTER so
// their app-specific selectors win on same-specificity ties.
import '@rynora/ui/ui.css';
import { AppThemeBoot } from '@rynora/theme';
import { App } from './App';
import './styles.css';
// MUST stay last among CSS imports — see styles-token-cascade.css.
import './styles-token-cascade.css';
import { getApiBaseUrl, loadPublicConfig } from './lib/config';

const API_BASE_URL = getApiBaseUrl();

// Fire-and-forget public-config load; later renders pick up the cache.
void loadPublicConfig().catch(() => {
  /* boot continues with sensible defaults */
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppThemeBoot appId="landing-page" apiBaseUrl={API_BASE_URL}>
        <App />
      </AppThemeBoot>
    </BrowserRouter>
  </React.StrictMode>,
);
